const LOGIN_URL = `${process.env.REACT_APP_AUTH_URL_PROTOCOL}://${process.env.REACT_APP_AUTH_URL}`;

export const doLogin = async (evt) => {
    const returnUrl = window.location.href;

    window.location.href = `${LOGIN_URL}?redirect=${returnUrl}`;
}